import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import {useTranslation} from 'react-i18next';
import i18n from "../../i18n";
import FormTextField from "../form/FormTextField";
import DialogActions from "@material-ui/core/DialogActions";
import {Button} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";

const startRideFormValidation = values => {
  console.log('validate', values);

  const errors = {};

  if (!values.bikeNumber) {
    errors.bikeNumber = i18n.t('common.validation.required');
  }

  return errors;
};

let StartRideForm = ({onSubmit, handleSubmit, onCancel}) => {
  const [t] = useTranslation();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group">
        <FormControl>
          <Field
            name="bikeNumber"
            type="text"
            component={FormTextField}
            label={t('unlockBike.startDialog.bikeNumber')}
            autoFocus
          />
        </FormControl>
      </div>
      <DialogActions>
        <Button
          type="submit"
          color="primary"
          variant="contained"
        >
          {t('common.confirmButton')}
        </Button>
        <Button
          type="button"
          onClick={onCancel}
          color="secondary"
        >
          {t('common.cancelButton')}
        </Button>
      </DialogActions>
    </form>
  );
};

StartRideForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

StartRideForm = reduxForm({
  form: 'startRideForm',
  validate: startRideFormValidation,
})(StartRideForm);

export default StartRideForm;
